import { Breakpoints } from '@angular/cdk/layout';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { useSelect } from '@bynary/composables/ngxs';
import { useBreakpoint } from '@bynary/composables/observer';
import { TranslateModule } from '@ngx-translate/core';
import { SonaAuthUserMenuFacade } from '@sona/angular-auth-domain';
import { SonaLanguageMenuComponent } from '@sona/angular-feature-language-menu';
import { SubscriptionService } from '@sona/angular-payments';
import { SonaIconComponent } from '@sona/angular-ui-components';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { BrnMenuImports } from '@spartan-ng/ui-menu-brain';
import { HlmMenuComponent, HlmMenuItemImports, HlmMenuStructureImports } from '@spartan-ng/ui-menu-helm';

@Component({
    selector: 'sona-auth-user-menu',
    imports: [
        RouterLink,
        TranslateModule,
        BrnMenuImports,
        HlmButtonDirective,
        SonaIconComponent,
        SonaLanguageMenuComponent,
        HlmMenuComponent,
        HlmMenuItemImports,
        HlmMenuStructureImports
    ],
    templateUrl: './user-menu.component.html',
    styleUrl: './user-menu.component.scss'
})
export class SonaAuthUserMenuComponent {
    private readonly _authFacade = inject(SonaAuthUserMenuFacade);
    private readonly _subscriptionService = inject(SubscriptionService);

    protected readonly isMobile = useBreakpoint(Breakpoints.Handset);
    protected readonly user = useSelect(SonaAuthUserMenuFacade.user);

    async openBillingPortal() {
        await this._subscriptionService.openBillingPortal();
    }

    updateUserLang(language: string) {
        if(!this.user) {
            return;
        }

        this._authFacade.updateUserLanguage(language);
    }

    async signOut() {
        await this._authFacade.signOut();
    }
}
